/* eslint-disable @typescript-eslint/no-explicit-any */ import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  pointer-events: ",
        ";\n\n  .iconn {\n    align-items: flex-start;\n    background: #ffffff1a;\n    border-radius: 12px;\n    display: flex;\n    gap: 10px;\n    padding: 8px;\n    margin-right: 12px;\n  }\n\n  .content {\n    color: #fff;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 140%;\n\n    align-items: flex-start;\n    display: flex;\n    flex: 1 0;\n    flex-direction: column;\n    gap: 4px;\n\n    .desc {\n      color: #fff9;\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 140%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  border: none;\n  border-radius: 0;\n\n  .ant-collapse-header-text {\n    color: ",
        ";\n  }\n\n  .ant-collapse-item {\n    border: none;\n    border-radius: 0 !important;\n\n    .ant-collapse-content-active {\n      padding-bottom: 16px;\n\n      ",
        " {\n        min-height: 60px;\n        height: auto;\n        padding: 12px 0;\n      }\n    }\n\n    @media screen and (max-width: 968px) {\n      min-height: 60px;\n      border-bottom: 0.5px solid hsla(0, 0%, 100%, 0.102);\n      background-color: #20233b;\n\n      .ant-collapse-header {\n        min-height: 58px;\n        align-items: center;\n        border-radius: 0 !important;\n      }\n\n      &:is(.ant-collapse-item-active) {\n        .ant-collapse-header {\n          min-height: unset;\n        }\n      }\n    }\n  }\n\n  .ant-collapse-content {\n    background: transparent;\n    border: none;\n  }\n\n  .ant-collapse-content-box {\n    padding: 0 !important;\n    margin-left: 20px;\n\n    & > div a {\n      border: none;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement, memo } from "react";
import { Collapse } from "antd";
import { ArrowDownIcon } from "@pancakeswap/uikit";
import styled from "styled-components";
import { Flex } from "../Box";
import isTouchDevice from "../../util/isTouchDevice";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import MenuItem from "../MenuItem/MenuItem";
var Panel = Collapse.Panel;
var StyledMenuItem = styled(MenuItem).withConfig({
    componentId: "sc-45ed6761-0"
})(_templateObject(), function(param) {
    var isActive = param.isActive;
    return isActive ? "none" : "unset";
});
var StyledCollapse = styled(Collapse).withConfig({
    componentId: "sc-45ed6761-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white60;
}, StyledMenuItem);
var MenuItems = function(_param) {
    var _items = _param.items, items = _items === void 0 ? [] : _items, activeItem = _param.activeItem, activeSubItem = _param.activeSubItem, isDrawer = _param.isDrawer, props = _object_without_properties(_param, [
        "items",
        "activeItem",
        "activeSubItem",
        "isDrawer"
    ]);
    if (!isDrawer) {
        return /*#__PURE__*/ _jsx(Flex, _object_spread_props(_object_spread({
            flexDirection: isDrawer ? "column" : "row"
        }, props), {
            children: items.map(function(param) {
                var label = param.label, tmp = param.items, menuItems = tmp === void 0 ? [] : tmp, href = param.href, icon = param.icon, disabled = param.disabled;
                var ref, ref1;
                var statusColor = (ref = menuItems === null || menuItems === void 0 ? void 0 : menuItems.find(function(menuItem) {
                    return menuItem.status !== undefined;
                })) === null || ref === void 0 ? void 0 : (ref1 = ref.status) === null || ref1 === void 0 ? void 0 : ref1.color;
                var isActive = activeItem === href;
                var linkProps = isTouchDevice() && menuItems && menuItems.length > 0 ? {} : {
                    href: href
                };
                var Icon = icon;
                return /*#__PURE__*/ _jsx(DropdownMenu, {
                    items: menuItems,
                    py: 1,
                    activeItem: activeSubItem,
                    isDisabled: disabled,
                    children: /*#__PURE__*/ _jsxs(StyledMenuItem, _object_spread_props(_object_spread({}, linkProps), {
                        isActive: label === "Prediction (BETA)",
                        statusColor: statusColor,
                        isDisabled: disabled,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                style: {
                                    color: label === "Prediction (BETA)" ? "#34f5ae" : "textSubtle"
                                },
                                children: label
                            }) || icon && /*#__PURE__*/ createElement(Icon, {
                                color: isActive ? "secondary" : "textSubtle"
                            }),
                            menuItems.length !== 0 && /*#__PURE__*/ _jsx(ArrowDownIcon, {
                                color: "white60",
                                width: "12px",
                                ml: "4px"
                            })
                        ]
                    }))
                }, "".concat(label, "#").concat(href));
            })
        }));
    }
    return /*#__PURE__*/ _jsx(StyledCollapse, {
        accordion: true,
        expandIconPosition: "end",
        expandIcon: function() {
            return /*#__PURE__*/ _jsx(ArrowDownIcon, {
                color: "#ffffff99",
                width: "12px"
            });
        },
        children: items.map(function(param) {
            var label = param.label, href = param.href, itemChild = param.items;
            var linkProps = isTouchDevice() && itemChild && itemChild.length > 0 ? {} : {
                href: href
            };
            return /*#__PURE__*/ _jsx(_Fragment, {
                children: itemChild && (itemChild === null || itemChild === void 0 ? void 0 : itemChild.length) > 0 ? /*#__PURE__*/ _jsx(Panel, {
                    header: /*#__PURE__*/ _jsx("span", {
                        className: "title-panel",
                        children: label
                    }),
                    children: itemChild.map(function(item) {
                        var Icon = item.icon;
                        return /*#__PURE__*/ _jsxs(StyledMenuItem, {
                            href: item.href,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "iconn",
                                    children: /*#__PURE__*/ _jsx(Icon, {})
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "content",
                                    children: [
                                        item.label,
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "desc",
                                            children: item.describe
                                        })
                                    ]
                                })
                            ]
                        });
                    })
                }, label) : /*#__PURE__*/ _jsx(StyledMenuItem, _object_spread_props(_object_spread({}, linkProps), {
                    children: /*#__PURE__*/ _jsx("span", {
                        style: {
                            color: label === "Prediction (BETA)" ? "#34f5ae" : "textSubtle"
                        },
                        children: label
                    })
                }))
            });
        })
    });
};
export default /*#__PURE__*/ memo(MenuItems);
